/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Vehicle_Paths_Journeys_And_LinesInputs */

const fr_settings_show_vehicle_paths_journeys_and_lines = /** @type {(inputs: Settings_Show_Vehicle_Paths_Journeys_And_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courses et lignes`)
};

const en_settings_show_vehicle_paths_journeys_and_lines = /** @type {(inputs: Settings_Show_Vehicle_Paths_Journeys_And_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trips and lines`)
};

/**
* | output |
* | --- |
* | "Trips and lines" |
*
* @param {Settings_Show_Vehicle_Paths_Journeys_And_LinesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_vehicle_paths_journeys_and_lines = /** @type {((inputs?: Settings_Show_Vehicle_Paths_Journeys_And_LinesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Vehicle_Paths_Journeys_And_LinesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_vehicle_paths_journeys_and_lines(inputs)
	return en_settings_show_vehicle_paths_journeys_and_lines(inputs)
});